import { type Time, type ZonedDateTime } from "@internationalized/date";
import { useTranslations } from "next-intl";
import { type Dispatch, type SetStateAction } from "react";
import { useDateFormatter, type CalendarAria } from "react-aria";
import { type CalendarState } from "react-stately";
import { Balancer } from "react-wrap-balancer";

import { XL } from "~/components/typography";
import { DialogAccordion } from "~/components/ui/dialog-accordion";

import { BookMeetingForm } from "./book-meeting-form";
import { BookMeetingTimePicker } from "./book-meeting-timepicker";
import { MeetingCalendar } from "./meeting-calendar";

export function MobileBookMeetingContent({
  calendar,
  setTimeSlot,
  state,
  timeSlots,
  zonedDateTime,
}: {
  calendar: CalendarAria;
  state: CalendarState;
  zonedDateTime: ZonedDateTime;
  setTimeSlot: Dispatch<SetStateAction<Time>>;
  timeSlots: Time[];
}) {
  const t = useTranslations("BookMeeting");
  const timeFormatter = useDateFormatter({ timeStyle: "short" });
  const dateFormatter = useDateFormatter({ dateStyle: "medium" });
  return (
    <>
      <XL className="mb-6 text-center">
        <Balancer>{t("title")}</Balancer>
      </XL>
      <DialogAccordion
        sections={[
          {
            children: (
              <div className="p-5" {...calendar.calendarProps}>
                <MeetingCalendar state={state} title={calendar.title} />
              </div>
            ),
            cta: dateFormatter.format(zonedDateTime.toDate()),
            label: "Date",
            value: "date",
          },
          {
            children: (
              <div className="p-5">
                <BookMeetingTimePicker
                  value={zonedDateTime}
                  setValue={setTimeSlot}
                  timeSlots={timeSlots}
                />
              </div>
            ),
            cta: timeFormatter.format(zonedDateTime.toDate()),
            label: "Time",
            value: "time",
          },
          {
            children: (
              <div className="p-5">
                <BookMeetingForm zonedDateTime={zonedDateTime} />
              </div>
            ),
            cta: "Submit",
            label: "Details",
            value: "details",
          },
        ]}
      />
    </>
  );
}
